<template>
    <!-- <div id="phtoalbum" class="menulink" @keydown.esc="$emit('goto', 'home')" tabindex="0" ref="focused"> -->
    <div id="photoalbum" class="menulink">
      <div>
        <!-- <div class="headline1"><router-link :to="{ name: 'gallery' }">{{ data.title }}</router-link></div> -->
                    <div class="menu-outer-wrapper">
                     <div class="headline1"><router-link to="/">{{ data.title }}</router-link></div>
                     <div class="menuwrapper">
                        <router-link class="menuitem" :to="{ name: 'videomenu'}"><div id="video">VIDEO</div></router-link>
                        <router-link class="menuitem" :to="{ name: 'gallery'}"><div id="foto">FOTO</div></router-link>
                        <router-link class="menuitem" :to="{ name: 'kontakt'}"><div id="kontakt">KONTAKT</div></router-link>
                     </div>
                  </div>

      <vue-picture-swipe v-if="data.photoalbums" :items="data.photoalbums[galleryId].images" :options="options"></vue-picture-swipe>
      <div class="headline2" v-if="data.photoalbums">{{ data.photoalbums[galleryId].description }}</div>
      </div>
    </div>
</template>

<script>
//https://github.com/rap2hpoutre/vue-picture-swipe
import VuePictureSwipe from 'vue-picture-swipe';

export default {
  name: 'PhotoAlbum',
  props: {
    data: Object
  },
    components: {
    VuePictureSwipe
  },
    data () {
    return {
      options: {
        //https://photoswipe.com/documentation/options.html
        shareEl: true,
        indexIndicatorSep: ' / ',
        counterEl: true
      }
    }
},
  async mounted() {
    console.log("Photoalbum mounted")
  },
  methods: {
  },
  computed: {
    galleryId() {
      return this.$route.params.gid
    }
  },
	watch: {
    // $route(to, from) {
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
